import { ProjectsAvailableSessionTypes } from "../../../../types/Projects";
import { ProjectFormController } from "../useProjectFormController";
import s from "../ProjectFormPage.module.css";

type SpecialistScopeStepProps = {
  controller: ProjectFormController;
};

const projectTypeOptions = [
  {
    value: ProjectsAvailableSessionTypes.SESSION,
    label: "Sessions",
  },
  {
    value: ProjectsAvailableSessionTypes.PACKAGE,
    label: "Packages",
  },
];

const SpecialistScopeStep = ({ controller }: SpecialistScopeStepProps) => {
  const toggleSpecialization = (specializationId: string) => {
    controller.setProjectData((prev) => {
      const current =
        prev.specializations?.length
          ? prev.specializations
          : controller.mainSpecializations.map((item) => item.value);
      const next = current.includes(specializationId)
        ? current.filter((item) => item !== specializationId)
        : [...current, specializationId];

      return {
        ...prev,
        specializations: next,
      };
    });
  };

  const toggleProjectType = (type: ProjectsAvailableSessionTypes) => {
    controller.setProjectData((prev) => {
      const currentTypes = controller.selectedProjectTypes;
      const nextTypes = currentTypes.includes(type)
        ? currentTypes.filter((item) => item !== type)
        : [...currentTypes, type];

      return {
        ...prev,
        availableSessionTypes: nextTypes.flatMap((projectType) =>
          controller.selectedSpecializationIds.map((specialization) => {
            const previous = prev.availableSessionTypes?.find(
              (item) =>
                item.type === projectType &&
                item.specialization === specialization,
            );

            return {
              type: projectType,
              specialization,
              amount: previous?.amount ?? 0,
              unlimited: previous?.unlimited ?? true,
            };
          }),
        ),
        pricing: nextTypes.includes(ProjectsAvailableSessionTypes.SESSION)
          ? prev.pricing
          : [],
        packagePricing: nextTypes.includes(ProjectsAvailableSessionTypes.PACKAGE)
          ? prev.packagePricing
          : [],
        staticSessionPrices: nextTypes.includes(
          ProjectsAvailableSessionTypes.SESSION,
        )
          ? prev.staticSessionPrices
          : false,
        staticPackagePrices: nextTypes.includes(
          ProjectsAvailableSessionTypes.PACKAGE,
        )
          ? prev.staticPackagePrices
          : false,
      };
    });
  };

  return (
    <div className={s.stepPanel}>
      <div className={s.section}>
        <h2 className={s.sectionTitle}>Specialist Scope</h2>
        <p className={s.sectionText}>
          Select which specialist specializations and Project offer types apply.
        </p>
      </div>

      <div className={s.fieldBlock}>
        <span className={s.fieldLabel}>Specializations</span>
        {controller.mainSpecializations.length ? (
          <div className={s.optionGrid}>
            {controller.mainSpecializations.map((specialization) => (
              <button
                key={specialization.value}
                type="button"
                className={`${s.optionButton} ${
                  controller.selectedSpecializationIds.includes(
                    specialization.value,
                  )
                    ? s.activeOptionButton
                    : ""
                }`}
                onClick={() => toggleSpecialization(specialization.value)}
              >
                {specialization.lable}
              </button>
            ))}
          </div>
        ) : (
          <div className={s.emptyState}>No specializations available.</div>
        )}
      </div>

      <div className={s.fieldBlock}>
        <span className={s.fieldLabel}>Project type</span>
        <div className={s.optionGrid}>
          {projectTypeOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`${s.optionButton} ${
                controller.selectedProjectTypes.includes(option.value)
                  ? s.activeOptionButton
                  : ""
              }`}
              onClick={() => toggleProjectType(option.value)}
              disabled={!controller.selectedSpecializationIds.length}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {controller.selectedSpecializationIds.length > 0 &&
        controller.specialistLevels.length === 0 && (
          <div className={s.emptyState}>
            No specialist levels found for the selected specializations.
          </div>
        )}
    </div>
  );
};

export default SpecialistScopeStep;
